// extracted by mini-css-extract-plugin
export default {"params":"params_params__ljxC4"};